<template>
    <div>
        <p class="loading text-center pt-5" v-if="loader.firstLoading">
            <i class="fas fa-spinner fa-spin" style="font-size:2rem"></i>
        </p>

        <div v-else>
            <div v-if="loader.rows.length">

                <base-table type="hover" :data="loader.rows">

                    <template slot="columns">
                        <th width="50px"></th>
                        <th>{{ $t('xapi.common.verb-id') }}</th>
                        <th class="text-right"></th>
                    </template>

                    <template slot-scope="{row}">

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null" 
                            class="td-actions"
                        >
                            <div class="index text-warning">
                                {{ row.index }}
                            </div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                        >
                            <div><small>{{ row.id }}</small></div>
                        </td>

                        <td class="text-right" 
                            @mouseover="hovered=row.index"
                            @mouseleave="hovered=null"
                        >
                            <div>
                                <a href="#" @click.prevent.stop="openStatements(row)">
                                    {{ $t('xapi.common.statements') }}
                                </a>
                            </div>
                        </td>

                    </template>

                </base-table>

                <div slot="footer" class="text-center mt-3" v-if="loader.hasMore()">
                    <base-button round type="primary" :loading="loader.nextLoading" @click="loader.nextLoad()">
                        {{ $t('common.load-more') }}
                    </base-button>
                </div>

            </div>
            
            <div v-else>
                <p class="text-center pt-3">{{ $t('xapi.common.search.no-result') }}</p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                loader: this.$xapi.loaders.verbs,
                filters: this.$xapi.filters.verbs,
                hovered: null,
                index: null,
            }
        },

        created() {
            this.loader.setMapData(this.mapData)
            this.loader.firstLoad()
        },

        methods: {

            mapData(item, index) {
                return {
                    index: index + 1,
                    id: item.iri,
                }
            },

            openStatements(row) {
                this.$xapi.filters.statements.reset()
                this.$xapi.filters.statements.verb = row.id
                this.$router.push({ name: 'statements' })
            }
        }
    }
</script>

<style scoped>

    td:hover {
        /*
        cursor: pointer;
        */
    }
    td .index {
        width: 30px;
        height: 30px;
        text-align: center;
        padding-top: 5px;
    }

</style>